

///import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";
//import { UserInfoStore } from "../shared/store/userInfo.store";

///import { Router } from "@angular/router";
declare const $:any;

// Modal Block 1------------------
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';
// Modal Block 1------------------

import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { RegistrationBasicService } from '../ApplicationServices/RegistrationBasicService';
import { RegistrationFeedbackService } from '../ApplicationServices/RegistrationFeedbackService';
import { RegistrationHealthService } from '../ApplicationServices/RegistrationHealthService';
import { SharedService } from '../ApplicationServices/SharedService';
import { PopUpService } from '../ApplicationServices/PopUpService';
import { UploadService } from '../ApplicationServices/UploadService';

import { ImageService } from '../ApplicationServices/ImageService';
import { BranchService } from '../ApplicationServices/BranchService';
import { CompanyService } from '../ApplicationServices/CompanyService';

import { ItemMasterBasic10_EarningPtsGeneratorService } from "../ApplicationServices/ItemMasterBasic10_EarningPtsGeneratorService";

import { ItemMasterHeaderSubDescService } from '../ApplicationServices/ItemMasterHeaderSubDescService';
import { RegistrationFeedbackElement } from '../models/RegistrationFeedbackModel';

import { ItemMasterBasic1_VitalService } from "../ApplicationServices/ItemMasterBasic1_VitalService";
import { ItemMasterBasic1_VitalElement } from '../models/ItemMasterBasic1_VitalModel';
import { LoginService } from "../ApplicationServices/LoginService";

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})

export class WishlistComponent implements OnInit {


  productzeropreData:any;   isattendanceData: any;    ROWCOUNT: number = 0;
  AttendanceCounts: string;     BalancePoints: string;  ReferralCounts: string;

  /////////////////////////// GridFill  /////////////////
  Arrayfeedback = [];   Formfeedback: FormGroup;    Arrayinterest = [];   Forminterest: FormGroup;

  Arrayearn = [];    Formearn: FormGroup;   Arrayredem = [];   Formredem: FormGroup;

  EARNINGSUM: string;  REDEEMSUM: string;  BALANCESUM: string;   POINTS:number=0;   FMID:number=0;

  basicForm: any;   healthForm1: any; healthForm2: any;    feedbackForm: any; feedbackForm1: any;    imgvcdcategoryData:any;
  imagesForm: FormGroup;   videoForm: FormGroup;   checkboxValue: boolean = false;    imgForm: FormGroup;
  InterestForm: any; 

  RIDSS : string;     RIDS : string;   FNAME : string;  MID : number;    FID:number=0;
  EditOperation : boolean = false;   EditeditOperation : boolean = false;  
   customerForm1: FormGroup;   customerdetails1 = [];    alertmsg:string=null;showalert:boolean=false;
   alertmsg1:string=null;showalert1:boolean=false;

   testingDataSet : any;   HealthCondition = 2;   GuestRating = 4;     loggedIn = false;     wishlistItems = []; 
   HealthMotion = 2;   HealthUrination = 2;    HealthSleep = 2; 
   IDSS :number =0;

   FixingHealthIssueData:any;  HealthIssueData:any;     UnderTreatmentData:any;  AddictionData:any;

    constructor(

      // private infoStore: UserInfoStore,
      // private router: Router,
      // private itemModifierService: ItemModifierService

      private modalService: NgbModal,  
      private fb: FormBuilder,
      private compService: CompanyService, private braService: BranchService,  private imgService: ImageService, 
  
      private uploadsvc: UploadService,
      private baService :RegistrationBasicService ,    private heService: RegistrationHealthService,
      private feService: RegistrationFeedbackService,
      private shareService: SharedService, private popService :PopUpService,
      private headerservice:ItemMasterHeaderSubDescService, 
      private router: Router,
      private earningptsService : ItemMasterBasic10_EarningPtsGeneratorService,
      private vitalService: ItemMasterBasic1_VitalService,
       private loginService: LoginService,

    ) 
    {

      /////////////////////////   GRIDFILL  ///////////////
      this.Formfeedback = this.fb.group({ Arrayfeedback : [""], });
      this.Formearn = this.fb.group({ Arrayearn : [""], });
      this.Formredem = this.fb.group({ Arrayredem : [""], });

      this.Forminterest = this.fb.group({ Arrayinterest : [""], });
      this.customerForm1 = this.fb.group({ customerdetails1: [""],  });


      this.InterestForm = new FormGroup({

        PrivilegeID : new FormControl(),
        //ItemName : new FormControl(),

      });

      this.feedbackForm = new FormGroup({

        AdmissionFeedbackId: new FormControl(),
        AdmissionMasterId: new FormControl(),
   
        //FeedBackDateTime: new FormControl(new Date()),
        FeedbackResult: new FormControl(),
        FeedbackNature: new FormControl(),
        HealthIssue: new FormControl(),
        OperatorsOpinion: new FormControl(),
        HealthCondition : new FormControl(),
        HealthMotion : new FormControl(),  HealthUrination : new FormControl(),  HealthSleep : new FormControl(),
        IsAttendanceRegular : new FormControl(),  AttendanceLastVisited : new FormControl(new Date()),
        GuestRating: new FormControl(),
        // HealthCondition = 2;   GuestRating = 4; 
   
   
      });


    }


    ///////////////////  GRIDFILL ////////////

    get selectedInterest() {
      return this.Forminterest.get("Arrayinterest").value;      
    }

    get selectedFeedback() {
      return this.Formfeedback.get("Arrayfeedback").value;      
    }

    get selectedEarn() {
      return this.Formearn.get("Arrayearn").value;      
    }

    get selectedRedem() {
      return this.Formredem.get("Arrayredem").value;      
    }


    get selectedAdress1() {

      return this.customerForm1.get("customerdetails1").value;
    
    }

    editCustomer1(id1, id2,  id3){

      this.EditOperation = true;  
      this.EditeditOperation = true;  
      

      //// this.MID=emps.AdmissionMasterId;    this.FID=emps.AdmissionFeedbackId;
  
      ////  item.AdmissionMasterId, item.RID, item.FullName
  
      this.RIDS="";    this.FNAME= "";   this.MID = 0;
  
      this.RIDS= id2 ;    this.FNAME=id3 ;   this.MID = id1;

      this.getAllFeedbackData();  
      //this.getAllPointsData();   
      this.getAllProduct();   this.getAllProductSelectedData();
      
      //this.onHealingUpdate();

    //   this.feService.getAllRegistrationFeedbackData(this.MID).subscribe((event: any) => {
       
        
       
    //    if (event.length > 0) {

    //         this.Arrayfeedback = event;


    //       } else {
    //         this.Arrayfeedback = [];
    //       }
  
    // }
    //    );    
  
  
  
      
    }    

    onLoadVisitorData(){

      this.alertmsg="data loading ..... !!";
      this.showalert=true;
     
      this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
      .subscribe((event: any) => {
  
  
         if (event.length > 0) {
  
              this.customerdetails1 = event;
  
  
            } else {
              this.customerdetails1 = [];
            }
    
      }
      );
    
      this.alertmsg="data loading ..... !!";
      this.showalert=true;
      setTimeout(() => {
        this.showalert=false;
      }, 9000);      
    
    
    }

    getVisitorData1(){

     
    
  
  
    }

    ResetPassword(){

      this.loginService.getPasswordReset(sessionStorage.getItem("UserName"))
      .subscribe((event: any) => {
        if (event.length > 0) {
    
        }
      });
    
     }

    FillSession(){

      if (sessionStorage.getItem("OrderMaster_Id")) {   
        this.loggedIn = true;      
        //this.ResetPassword(); 
      } 
      else 
      {
        this.loggedIn = false; 
      }
    
    
     }

     ///   getAllFixingHealthIssue     FixingHealthIssue
    getAllFixingHealthIssue(){

   this.popService.getAllPopUpByIdData("FixingHealthIssue")
  .subscribe(
    (data) => {
      this.FixingHealthIssueData = data;
    }
  );


    }

    onLoadFeedbackData(){

    this.getAllFeedbackData();

    }

    getAllFeedbackData(){

        //this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
        this.feService.getAllRegistrationFeedbackData(this.MID).subscribe((event: any) => {
  
  
          //////////////////////  GRIDFILL /////////////
         if (event.length > 0) {
  
              this.Arrayfeedback = event;
  
  
            } else {
              this.Arrayfeedback = [];
            }
    
      }
         );
    
  
  
    }

    ///////////////  GRIDFILL //////////////////
    editFeedbackParticular(id)
    {



    }
    deleteFeedbackParticular(ids){


    this.FID = ids;


    }

    
    loginredirect() {
     this.router.navigateByUrl("login");
    }


 

    onHealingUpdate(){


      this.alertmsg1="on progress ..... !!";
      this.showalert1=true;
    
      this.baService.addAdmissionDetailsCategorizeData( 0, this.MID,Number(sessionStorage.getItem("LoggedInId")), 'HEALING', 1, '' )
      .subscribe(
      (datacc) => {
    
    
        
        ///this.getAllCategorizeData();
      
        this.alertmsg1="Updated Successfully ..... !!";
        this.showalert1=true;
        setTimeout(() => {
          this.showalert1=false;
        }, 2000);
    
        ///this.CATEGORIZENAME== '';
    
      }
      );


    }
    

    

    getAllProductSelectedData(){

      //this.baService.getAllRegistrationBasicData( "NO",Number(sessionStorage.getItem("LoggedInId")), 1, 13 )
      this.vitalService.getAllMidItemIdMAPPINGData( this.MID , 1 ).subscribe((event: any) => {

        //////////////////////  GRIDFILL /////////////
       if (event.length > 0) {
            this.Arrayinterest = event;
          } else {
            this.Arrayinterest = [];
          }  
       }
       ); 


    }

    getIsAttendanceList(){

    this.isattendanceData=[
      
    { IsAttendanceRegular: "YES" },
    { IsAttendanceRegular: "NO" }    

    ];

    }

    
    getAllPointsDataOld(){

      this.alertmsg1="on progress ..... !!";
      this.showalert1=true;
  
      this.testingDataSet = null;  
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 37,  Number(sessionStorage.getItem("LoggedInId"))  ).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_RedeemLedgerMaster = data;
      // this.dataSource_RedeemLedgerMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerMaster); 
      
      ///  EARNINGSUM    REDEEMSUM    BALANCESUM
            this.testingDataSet = data;
            if(  this.testingDataSet.length == 0  )
            {
              this.EARNINGSUM = '0';   this.REDEEMSUM = '0';   this.BALANCESUM = '0';
            }
            else{ 
                this.EARNINGSUM = data[0].EarnedPts ;   
                this.REDEEMSUM = data[0].RedeemedPts ; 
                this.BALANCESUM = data[0].BalancedPts ; 
            } 

      });



      //////////   attendance count  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 30,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.AttendanceCounts = (data[0].AttendanceCount);   

      });


      //////////   attendance details  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 31,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_Attendance = data;
      //this.dataSource_Attendance = new MatTableDataSource(this.ELEMENT_DATA_Attendance); 

      });


      //////////   referral count  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 32,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ReferralCounts  = (data[0].ReferralCount);   

      });


      //////////   referral details  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 33,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_Referral = data;
      //this.dataSource_Referral = new MatTableDataSource(this.ELEMENT_DATA_Referral);  

      });


        //////////   redeem count  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 34,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.RedeemCounts  = (data[0].RedeemPoints);   

      });


        //////////   redeem ledger details  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 35,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_RedeemLedgerDetails = data;
    //  this.dataSource_RedeemLedgerDetails = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerDetails);   

      });

          //////////   redeem plan master  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 36,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_RedeemPlanMaster = data;
      //this.dataSource_RedeemPlanMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemPlanMaster);   

      });


            //////////   redeem ledger master  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 37,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_RedeemLedgerMaster = data;
      // this.dataSource_RedeemLedgerMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerMaster);   

      });



                //////////   earning rule  ///////////////
      this.earningptsService.getItemMasterBasic10_Pts( this.MID, 38,  Number(sessionStorage.getItem("LoggedInId"))).subscribe(
      (data) => {
            
      //this.ELEMENT_DATA_EarningRule = data;
      // this.dataSource_EarningRule = new MatTableDataSource(this.ELEMENT_DATA_EarningRule);   

      });


      this.alertmsg1="Data loading is completed ..... !!";
      this.showalert1=true;
      setTimeout(() => {
      this.showalert1=false;
      }, 1000);


    ///  007
    // this.earningptsService.GetAllEarningRedemmPoints( this.MID, 0, 1  ) 
    // .subscribe(
    //   (data) => {

    //     this.ELEMENT_DATA_301 = data;
    //     this.dataSource_301 = new MatTableDataSource(this.ELEMENT_DATA_301);
    //     //this.dataSource_301.paginator = this.paginator;

      
    //   }

    // );
    
    // this.earningptsService.GetAllEarningRedemmPoints( this.MID, 0 , 2  ) 
    // .subscribe(
    //   (data) => {

    //     this.ELEMENT_DATA_302 = data;
    //     this.dataSource_302 = new MatTableDataSource(this.ELEMENT_DATA_302);
    //     /// this.dataSource_302.paginator = this.paginator; 
      
    //   }

    // );

      //    EARNINGSUM: string;  REDEEMSUM: string;  BALANCESUM: string;
    //  str= datas[0].OperationStatus;

    //  this.testingDataSet = null; 
    //  this.earningptsService.GetAllEarningRedemmPoints( this.MID, 0,  3 ) 
    // .subscribe(
    //   (data) => {

    //     this.testingDataSet = data;
    //     if(  this.testingDataSet.length == 0  )
    //     {
    //       this.EARNINGSUM = '0';
    //     }
    //     else{ 
    //       this.EARNINGSUM = data[0].EarnedPts ;    
    //     }
      
      
    //   }

    // );


    // this.testingDataSet = null; 
    // this.earningptsService.GetAllEarningRedemmPoints( this.MID, 0, 4  ) 
    // .subscribe(
    //   (data) => {

          
    //     this.testingDataSet = data;
    //     if(  this.testingDataSet.length == 0  )
    //     {
    //       this.REDEEMSUM = '0';
    //     }
    //     else{ 
    //       this.REDEEMSUM = data[0].RedeemedPts ;    
    //     } 
      
    //   }

    // );

    // this.testingDataSet = null;  
    // this.earningptsService.GetAllEarningRedemmPoints( this.MID,  0,  5  ) 
    // .subscribe(
    //   (data) => {

          
    //     this.testingDataSet = data;
    //     if(  this.testingDataSet.length == 0  )
    //     {
    //       this.BALANCESUM = '0';
    //     }
    //     else{ 
    //       this.BALANCESUM = data[0].BalancedPts ;   
    //     } 
      
    //   }

    // );


    // this.showalert = true;
    // setTimeout(() => {
    // this.showalert = false;
    // }, 2000);



    }


     getAllPointsData(){
    
    // this.ELEMENT_DATA_RedeemLedgerMaster = null;
    // this.dataSource_RedeemLedgerMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerMaster);                      
    // this.ELEMENT_DATA_RedeemLedgerDetails = null;
    // this.dataSource_RedeemLedgerDetails = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerDetails);                      
    // this.ELEMENT_DATA_Attendance = null;
    // this.dataSource_Attendance = new MatTableDataSource(this.ELEMENT_DATA_Attendance);                      
    // this.ELEMENT_DATA_Referral = null;
    // this.dataSource_Referral = new MatTableDataSource(this.ELEMENT_DATA_Referral);  
    
  
    this.BalancePoints = '0';     this.AttendanceCounts = '0';  this.ReferralCounts="0";

    // this.ELEMENT_DATA_test = null;
    // this.dataSource_test = new MatTableDataSource(this.ELEMENT_DATA_test);                      
    ////this.ROWCOUNT = 0; this.AttendanceCounts ='0';

    /////  prc  Cursor_EarningRedeemingCouponCalculation  earningptsService
      
    this.earningptsService.getAllEarningRedeemingCouponCalculationData( this.MID ).subscribe(
    (data) => {
                

                     ///////////////////   attendance points count ///////////////
                                                       
                       
                     this.ROWCOUNT = Array.isArray((data as any).Table) ? (data as any).Table.length : 0;

      
                     if( this.ROWCOUNT==0 ){    
                      
                      // this.ELEMENT_DATA_test = null;
                      // this.dataSource_test = new MatTableDataSource(this.ELEMENT_DATA_test);                      
                      // this.ROWCOUNT = 0;
                      // this.AttendanceCounts ='0';
    
                     }
                     else{    

                       this.AttendanceCounts =
                      (data as any).Table && (data as any).Table[0]
                        ? (data as any).Table[0].DailyAttendanceEarnedPoints
                        : 0;

                     }
          

                     ///////////////////   ledger master ///////////////
                   //  this.ELEMENT_DATA_test = data[1];
                   //  this.dataSource_test = new MatTableDataSource(this.ELEMENT_DATA_test);
                     // this.ROWCOUNT = Number(this.dataSource_test.data[1].length);
                   //  this.ROWCOUNT = Array.isArray(this.ELEMENT_DATA_test) ? this.ELEMENT_DATA_test.length : 0;
      
                     this.ROWCOUNT = Array.isArray((data as any).Table1) ? (data as any).Table1.length : 0;


                     if( this.ROWCOUNT==0 ){    
                      
                      // this.ELEMENT_DATA_RedeemLedgerMaster = null;
                      // this.dataSource_RedeemLedgerMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerMaster);                      
                      // this.ROWCOUNT = 0;
    
                     }
                     else{    
                     
                     /// this.ELEMENT_DATA_RedeemLedgerMaster =  (data as any).Table1; 
                   ///   this.dataSource_RedeemLedgerMaster = new MatTableDataSource(this.ELEMENT_DATA_RedeemLedgerMaster);                      
    
                           // this.BalancePoints =
                         // (data as any).Table && (data as any).Table[1]
                       //   ? (data as any).Table[1].BalancedPts
                      //   : 0;


                      this.BalancePoints =
                      (data as any).Table1 &&
                      (data as any).Table1[0] &&
                      (data as any).Table1[0].BalancedPts !== undefined
                      ? (data as any).Table1[0].BalancedPts
                      : 0;



                     }

                   



    });


     }

    ngOnInit() {

      this.FillSession();  //this.getAllProduct();   
      this.getIsAttendanceList();
      this.EARNINGSUM="";  this.REDEEMSUM="";   this.BALANCESUM="";
      this.POINTS=0;
      ///this.getAllFixingHealthIssue();
      this.EditeditOperation = false;
      this.EditOperation = false;   this.feedbackForm.reset();
      this.feedbackForm.patchValue({FeedbackNature: "HEALTH_ISSUE"});  this.feedbackForm.patchValue({HealthIssue: "N/A"});

      this.onLoadVisitorData();


    }


    getAllProduct() {

      this.vitalService.getAllMidItemIdMAPPINGData( this.MID , 0 )
      .subscribe(
        (datacoun) => {
 
          this.productzeropreData = datacoun;
 
        }
 
      );
    } 

    onInterestSubmit( datas ){

    ////  PrivilegeID  IsPermitted  CreatedBy Number(sessionStorage.getItem("LoggedInId"))

     this.vitalService.UpdateMidItemIdMapping( datas.PrivilegeID, 1, Number(sessionStorage.getItem("LoggedInId")) )
     .subscribe(
     (datas) => {

       //var str = null;
      //str = datacc

      var str1=null;
      str1= datas[0].OperationStatus.toString();  

      this.getAllProductSelectedData();

    this.alertmsg=str1;
    this.showalert=true;
    setTimeout(() => {
      this.showalert=false;
    }, 2000);

     }
     );

     //this.getAllProduct();


    }

    onLoadInterestData(){

      this.getAllProduct();
    }



    onFeClear() {

      this.feedbackForm.reset();  
      //this.feedbackForm1.reset();
      this.HealthCondition = 0;   this.GuestRating = 0; 
    
    }

    convertDate(inputFormat) {
   function pad(s) { return (s < 10) ? '0' + s : s; }
   var d = new Date(inputFormat)
   return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
  }

    onFeSubmit(datas) {

      if(   this.MID== null || this.MID== 0  )
      {
    
                this.alertmsg="Fill up Essential Information First !";
                this.showalert=true;
                setTimeout(() => {
                this.showalert=false;
                }, 2000);
                return;
    
       }
    
      if(  datas.FeedbackResult ==null    )
      {
    
                this.alertmsg="Feedback Field Cant Be Saved !";
                this.showalert=true;
                setTimeout(() => {
                this.showalert=false;
                }, 2000);
    
                return;
    
       }else{
    
    
      var objj = new RegistrationFeedbackElement();
    
      objj.AdmissionMasterId=this.MID;
    
      //objj.FeedBackDateTime = this.convertDate(datas.FeedBackDateTime);
     
    
      if( this.EditeditOperation==true )
      {
      objj.Notes = "NEW";
      }else{
      objj.Notes = "NEW";
      }
    
         objj.FeedbackNature=datas.FeedbackNature;  
      // HEALTH_ISSUE
     // objj.FeedbackNature='HEALTH_ISSUE';
      objj.FeedbackResult =datas.FeedbackResult;
      objj.OperatorsOpinion=datas.OperatorsOpinion;
    
      objj.HealthIssue=datas.HealthIssue;
      objj.HealthCondition= this.HealthCondition;  
      objj.GuestRating= this.GuestRating;

      objj.HealthMotion= this.HealthMotion;   objj.HealthUrination= this.HealthUrination; 
      objj.HealthSleep= this.HealthSleep;   objj.IsAttendanceRegular= datas.IsAttendanceRegular;
      objj.AttendanceLastVisited=  this.convertDate(datas.AttendanceLastVisited); 
    
      //   HealthCondition : new FormControl(),
     
      objj.CreatedBy = Number(sessionStorage.getItem("LoggedInId"));
      objj.MachineIP = sessionStorage.getItem("LongitudeLatitude");
      //objj.AdmissionMasterId=0;
    
     if (this.EditOperation==false)
      {
    
        objj.AdmissionFeedbackId = 0;
        objj.OperationType = "insert";
    
        this.feService.addRegistrationFeedbackData(objj)
          .subscribe(
            (datas) => {
    
              var str1=null;
              str1= datas[0].OperationStatus.toString();
    
              this.alertmsg=str1;
              this.showalert=true;
              setTimeout(() => {
              this.showalert=false;
              }, 2000);
    
              console.log(datas);  this.getAllFeedbackData();
              //this.getAllFe();
    
            });
      } else {
    
    
        objj.AdmissionFeedbackId = this.FID;
        objj.OperationType = "update";
    
        this.feService.addRegistrationFeedbackData(objj)
          .subscribe(
            (datas) => {
    
              var str1=null;
              str1= datas[0].OperationStatus.toString();
    
              this.alertmsg=str1;
              this.showalert=true;
              setTimeout(() => {
              this.showalert=false;
              }, 2000);
    
             console.log(datas);  this.getAllFeedbackData();
             // this.getAllFe();
    
            });
      }
    
    }
    
    // this.empModalReference.close();
    this.EditeditOperation = false;
   
    this.onFeClear();
    
    }
    
   


  }
